export default "__VITE_ASSET__BDpnvX4B__"